export const GET_DOCUMENT_TYPES = "GET_DOCUMENT_TYPES"
export const GET_DOCUMENT_TYPES_SUCCESS = "GET_DOCUMENT_TYPES_SUCCESS"
export const GET_DOCUMENT_TYPES_FAIL = "GET_DOCUMENT_TYPES_FAIL"

export const DOCUMENT_TYPE_API_ERROR = "DOCUMENT_TYPE_API_ERROR"